import { type RefObject, useEffect, useState } from "react";

export const useAnimate = ({ ref }: { ref: RefObject<HTMLDivElement> }) => {
  const [animateKey, setAnimateKey] = useState<number>(0);
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          setAnimateKey((prev) => prev + 1);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.8 },
    );
    observer.observe(ref.current);
  }, [ref]);

  return animateKey;
};
